import { Card, CardContent } from "../components/ui/card";

export interface ComingSoonProps {
  feature: string;
  plannedUnit: string;
}

export function ComingSoonPage({ feature, plannedUnit }: ComingSoonProps) {
  return (
    <section
      className="p-6 max-w-3xl mx-auto space-y-4"
      role="region"
      aria-label={`${feature} coming soon`}
    >
      <header>
        <h1 className="font-display text-3xl font-medium tracking-tight text-on-surface">{feature}</h1>
        <p className="mt-1 text-sm text-on-surface-variant">
          This surface has not shipped yet.
        </p>
      </header>
      <Card>
        <CardContent>
          <p className="text-sm text-on-surface-variant">
            Planned in roadmap unit{" "}
            <span className="font-mono">{plannedUnit}</span>.
          </p>
        </CardContent>
      </Card>
    </section>
  );
}
